<template src="./Config.html"></template>

<script>
import topMenu from "@/components/alert/components/topMenu";
import Pagination from "@/components/components/pagination";
import {createNamespacedHelpers} from "vuex";

const {mapGetters, mapActions} = createNamespacedHelpers('alert/config');

export default {
  name: "control",
  data() {
    return {
      showOverlay: false,
      percents: [],
      periodValue: null,
    }
  },
  components: {
    topMenu,
    Pagination,
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'SAVE',
    ]),
    save: function () {
      this.$store.commit('alert/config/PERIOD_VALUE', this.periodValue);
      this.SAVE({th: this})
    }
  },
  computed: {
    ...mapGetters([
      'PERCENTS',
      'PERIOD_LIST',
      'PERIOD_VALUE',
    ]),
    getPeriodOptions: function () {
      let options = [];
      this.PERIOD_LIST.forEach((val) => {
        options.push({ value: val, text: val });
      });
      return options;
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('alert') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }

    if (this.METRICS != null && this.APPLICATION != null && this.SEARCH_DEMAND != null) {
      this.metrics = this.METRICS
      this.application = this.APPLICATION
      this.searchDemand = this.SEARCH_DEMAND
    } else {
      this.GET_DATA({th: this});
    }
  }
}
</script>

<style scoped>
.add-role {
  text-align: left;
}

.input-add-use {
  margin-top: 0.1em;
}

#roles i {
  display: inline-block;
  width: 100%;
  height: 38px;
  vertical-align: middle;
  line-height: 38px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

#roles .t-cell {
  overflow: hidden;
}

.cell-cursor {
  cursor: cell;
}
.chart-box {
  width: 365px;
}
</style>